export const SET_SEDI = 'SET_SEDI';
export const SET_RUOLI = 'SET_RUOLI';
export const SET_SESSI = 'SET_SESSI';
export const SET_STATI_UTENTI = 'SET_STATI_UTENTI';
export const SET_STATI_CONCILIAZIONE = 'SET_STATI_CONCILIAZIONE';
export const SET_TIPI_CONCILIAZIONE = 'SET_TIPI_CONCILIAZIONE';
export const SET_TIPI_GIORNATA = 'SET_TIPI_GIORNATA';
export const SET_SINDACATI = 'SET_SINDACATI';
